import Preset_Default_IMG from "./landscape/Preset_Default.png";
import Preset_Inverted_IMG from "./landscape/Preset_Inverted.png";
import Preset_TopRightCam_IMG from "./landscape/Preset_TopRightCam.png";
import Preset_TopLeftCam_IMG from "./landscape/Preset_TopLeftCam.png";
import Preset_SideBySide_RightCam_IMG from "./landscape/Preset_SideBySide_RightCam.png";
import Preset_SideBySide_LeftCam_IMG from "./landscape/Preset_SideBySide_LeftCam.png";
import Preset_BottomRightMiniCam_IMG from "./landscape/Preset_BottomRightMiniCam.png";
import Preset_BottomLeftMiniCam_IMG from "./landscape/Preset_BottomLeftMiniCam.png";
import Preset_WebcamFull_IMG from "./landscape/Preset_WebcamFull.png";
import Preset_ScreenFull_IMG from "./landscape/Preset_ScreenFull.png";

import Preset_SideCamStacked_IMG from "./portrait/Preset_SideCamStacked.png";
import Preset_SideCamStackedInverted_IMG from "./portrait/Preset_SideCamStackedInverted.png";
import Portrait_ScreenFull_IMG from "./portrait/Preset_ScreenFull.png";
import Portrait_WebcamFull_IMG from "./portrait/Preset_WebcamFull.png";

import Square_CamBottomRight_IMG from "./square/Preset_CamBottomRight.png";
import Square_CamBottomLeft_IMG from "./square/Preset_CamBottomLeft.png";
import Square_CamTopRight_IMG from "./square/Preset_CamTopRight.png";
import Square_CamTopLeft_IMG from "./square/Preset_CamTopLeft.png";

import Square_ScreenFull_IMG from "./square/Preset_ScreenFull.png";
import Square_WebcamFull_IMG from "./square/Preset_WebcamFull.png";

import {
  Preset_WebcamFull,
  Preset_ScreenFull,
  PresetFn,
  landscapePresets,
  portraitPresets,
  squarePresets,
} from "./layoutPresets";



export interface LayoutPresetWithPreview {
  key: string;
  name: string;
  preset: PresetFn;
  preview: string; // imported image
  requiresWebcam: boolean;
  requiresScreen: boolean;
}


export const landscapePresetsWithPreview: LayoutPresetWithPreview[] = [
  {
    key: "Preset_WebcamFull",
    name: "Webcam Only",
    preset: Preset_WebcamFull,
    preview: Preset_WebcamFull_IMG,
    requiresWebcam: true,
    requiresScreen: false,
  },
  {
    key: "Preset_ScreenFull",
    name: "Screen Only",
    preset: Preset_ScreenFull,
    preview: Preset_ScreenFull_IMG,
    requiresWebcam: false,
    requiresScreen: true
  },
  {
    key: "Preset_Default",
    name: "Screen Left · Cam Right",
    preset: landscapePresets.Preset_Default,
    preview: Preset_Default_IMG,
    requiresWebcam: true,
    requiresScreen: true
  },
  {
    key: "Preset_Inverted",
    name: "Cam Left · Screen Right",
    preset: landscapePresets.Preset_Inverted,
    preview: Preset_Inverted_IMG,
    requiresWebcam: true,
    requiresScreen: true
  },
  {
    key: "Preset_TopRightCam",
    name: "Small Cam Top Right",
    preset: landscapePresets.Preset_TopRightCam,
    preview: Preset_TopRightCam_IMG,
    requiresWebcam: true,
    requiresScreen: true
  },
  {
    key: "Preset_TopLeftCam",
    name: "Small Cam Top Left",
    preset: landscapePresets.Preset_TopLeftCam,
    preview: Preset_TopLeftCam_IMG,
    requiresWebcam: true,
    requiresScreen: true
  },

  {
    key: "Preset_BottomRightMiniCam",
    name: "Small Cam Bottom Right",
    preset: landscapePresets.Preset_BottomRightMiniCam,
    preview: Preset_BottomRightMiniCam_IMG,
    requiresWebcam: true,
    requiresScreen: true
  },
  {
    key: "Preset_BottomLeftMiniCam",
    name: "Small Cam Bottom Left",
    preset: landscapePresets.Preset_BottomLeftMiniCam,
    preview: Preset_BottomLeftMiniCam_IMG,
    requiresWebcam: true,
    requiresScreen: true
  },
  
  {
    key: "Preset_SideBySide_RightCam",
    name: "Screen · Large Cam (Right)",
    preset: landscapePresets.Preset_SideBySide_RightCam,
    preview: Preset_SideBySide_RightCam_IMG,
    requiresWebcam: true,
    requiresScreen: true
  },
  {
    key: "Preset_SideBySide_LeftCam",
    name: "Large Cam · Screen (Right)",
    preset: landscapePresets.Preset_SideBySide_LeftCam,
    preview: Preset_SideBySide_LeftCam_IMG,
    requiresWebcam: true,
    requiresScreen: true
  },
];



export const portraitPresetsWithPreview: LayoutPresetWithPreview[] = [
  {
    key: "Preset_ScreenFull",
    name: "Screen Only (Portrait)",
    preset: Preset_ScreenFull,
    preview: Portrait_ScreenFull_IMG,
    requiresWebcam: false,
    requiresScreen: true,
  },
  {
    key: "Preset_WebcamFull",
    name: "Webcam Only (Portrait)",
    preset: Preset_WebcamFull,
    preview: Portrait_WebcamFull_IMG,
    requiresWebcam: true,
    requiresScreen: false,
  },
  {
    key: "Preset_SideCamStacked",
    name: "Stacked · Screen on Top",
    preset: portraitPresets.Preset_SideCamStacked,
    preview: Preset_SideCamStacked_IMG,
    requiresWebcam: true,
    requiresScreen: true
  },
  {
    key: "Preset_SideCamStackedInverted",
    name: "Stacked · Webcam on Top",
    preset: portraitPresets.Preset_SideCamStackedInverted,
    preview: Preset_SideCamStackedInverted_IMG,
    requiresWebcam: true,
    requiresScreen: true
  },
];



export const allPresetsWithPreview: LayoutPresetWithPreview[] = [
  ...landscapePresetsWithPreview,
  ...portraitPresetsWithPreview,
];

export const getPresetByKey = (key: string): LayoutPresetWithPreview | undefined => {
  return allPresetsWithPreview.find(p => p.key === key) || 
         squarePresetsWithPreview.find(p => p.key === key);
};

export const squarePresetsWithPreview: LayoutPresetWithPreview[] = [
  {
    key: "Preset_ScreenFull",
    name: "Screen Only (Square)",
    preset: Preset_ScreenFull,
    preview: Square_ScreenFull_IMG,
    requiresWebcam: false,
    requiresScreen: true,
  },
  {
    key: "Preset_WebcamFull",
    name: "Webcam Only (Square)",
    preset: Preset_WebcamFull,
    preview: Square_WebcamFull_IMG,
    requiresWebcam: true,
    requiresScreen: false,
  },
  {
    key: "Preset_CamBottomRight",
    name: "Small Cam Bottom Right",
    preset: squarePresets.Preset_CamBottomRight,
    preview: Square_CamBottomRight_IMG,
    requiresWebcam: true,
    requiresScreen: true
  },
  {
    key: "Preset_CamBottomLeft",
    name: "Small Cam Bottom Left",
    preset: squarePresets.Preset_CamBottomLeft,
    preview: Square_CamBottomLeft_IMG,
    requiresWebcam: true,
    requiresScreen: true
  },
  {
    key: "Preset_CamTopRight",
    name: "Small Cam Top Right",
    preset: squarePresets.Preset_CamTopRight,
    preview: Square_CamTopRight_IMG,
    requiresWebcam: true,
    requiresScreen: true
  },
  {
    key: "Preset_CamTopLeft",
    name: "Small Cam Top Left",
    preset: squarePresets.Preset_CamTopLeft,
    preview: Square_CamTopLeft_IMG,
    requiresWebcam: true,
    requiresScreen: true
  },
];



